import React from "react"
import badge from "badges/conquered-planet.svg"
import { BadgeImage } from "backpack/badges/styled"

const ConqueredPlanet = props => <BadgeImage src={badge} {...props} />

export default ConqueredPlanet
